import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../consts/api";
import { http } from "../../../../services/HttpService";

export const useRemoveExpirationDate = () => {
  return useMutation((dto) =>
    http.put(HTTP_ENDPOINTS.removeExpirationDate(), dto),
  );
};
